import React from 'react'

import {Message} from 'semantic-ui-react'

import './ErrorAlert.css'

const ErrorAlert = ({error}) => {
    return (
      	<div className={"ErrorAlert" + (error ? "" : " hidden")}>
        	<Message header={error} negative/>
      	</div>
    )
} 

export default ErrorAlert;

